import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'boldSpan',
	standalone: true
})
export class BoldSpanPipe implements PipeTransform {
	transform(value: string, regex) {
		return this.replace(value, regex);
	}

	replace(str, regex) {
		return str?.replace(new RegExp(`\\b${regex}\\b`, 'gi'), '<b>$&</b>');
	}
}